import React from "react";
import { useDropzone } from "react-dropzone";

const Dropzone = ({ onDrop, accept, onDropRejected }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept,
    onDropRejected,
  });

  return (
    <div {...getRootProps()} className="upload-button">
      <input className="dropzone-input" {...getInputProps()} />
      <i className="fas fa-plus"></i>
      <i className="fas fa-file-image"></i>
    </div>
  );
};

export default Dropzone;
